
import { useForecastCalculation as useForecastCalculationOriginal } from './useForecastCalculationMain';
import { useForecastCalculationWebWorker } from './useForecastCalculationWorker';

const supportsWebWorkers = typeof Worker !== 'undefined';
const useWebWorkers = supportsWebWorkers && process.env.REACT_APP_USE_WEB_WORKERS !== 'false';
export const useForecastCalculationSmart = useWebWorkers 
  ? useForecastCalculationWebWorker 
  : useForecastCalculationOriginal;

export { useForecastCalculationSmart as useForecastCalculation };

export { useForecastCalculationOriginal, useForecastCalculationWebWorker };

export const isUsingWebWorkers = useWebWorkers;

